import { Permission } from '@app/models'
import { usersApi } from '@app/services'

import { FetchPermissionsResponse } from './types'

export const fetchPermissions = async (
  userId: number
): Promise<Permission[]> => {
  const { data } = await usersApi.get<FetchPermissionsResponse>(
    `/users/${userId}/permissions`
  )

  return data.permissions
}
